interface IOrderMessage {
    code: string
    parameters: string[] | undefined
    severity: string
}

interface IRectifiedQtyItem {
    partNumber: number | undefined
    orderItemId: number | undefined
    reducedFrom: string | undefined
    reducedTo: string | undefined
}

export function rectifyItemsByOrderMessage(orderMessages: IOrderMessage[] | undefined): IRectifiedQtyItem[] | undefined {
    const rectifiedQuantityItems = orderMessages
        ?.filter((item: IOrderMessage) => item.code === 'ITEM_STOCK_REDUCED' || item.code === 'CART_LIMIT_QTY_REDUCED')
        ?.map((item: IOrderMessage) => ({
            partNumber: Number(item?.parameters?.[1]),
            orderItemId: Number(item?.parameters?.[0]),
            reducedFrom: item?.parameters?.[3],
            reducedTo: item?.parameters?.[2],
        }))

    return rectifiedQuantityItems
}
